import { Component, OnInit } from '@angular/core';
import {select, Store} from '@ngrx/store';
import {GetSAPConfiguration, GetSAPConfigurations} from './store/actions/sap-actions';
import {SapConfigurationsSelector} from './store/selectors/sap-selectors';
import {Observable} from 'rxjs/Observable';
import {Subscriber} from 'rxjs/Subscriber';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-connect-sap-cp',
  templateUrl: './connect-sap-cp.component.html',
  styleUrls: ['./connect-sap-cp.component.scss']
})
export class ConnectSapCpComponent implements OnInit {

  sapConfigurations: ISAPConfiguration[];
  sapConfigurations$:any;
  sapConfigurationSub: any;
  selectedConfig : ISAPConfiguration;
  isLoading:boolean;
  constructor(private store: Store<IAppState>) {

  }

  ngOnInit() {
    this.isLoading = true;
    this.sapConfigurations$ = this.store.pipe(select(SapConfigurationsSelector));
    this.sapConfigurationSub =  this.sapConfigurations$.subscribe((sapConfigurations: ISAPConfiguration[])=>{
      if(sapConfigurations && sapConfigurations.length > 0){
        this.sapConfigurations = [...sapConfigurations];
         this.sapConfigurations.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (b.name > a.name) {
            return -1;
          }
          return 0;
        });
        this.isLoading = false;
      }
      else{
        this.store.dispatch(new GetSAPConfigurations())
      }
    })
    this.store.dispatch(new GetSAPConfigurations())
  }

  cancelAction(){
    this.selectedConfig = null;
  }
  ngOnDestroy(){
    if(this.sapConfigurationSub){
      this.sapConfigurationSub.unsubscribe();
    }
  }

  applySelectConnector(config:ISAPConfiguration){
    this.selectedConfig = config;
  }

}

